import LogRocket from 'logrocket'

interface ParsedBody {
  newPassword?: string
  retypePassword?: string
  password?: string
  currentPassword?: string
  [key: string]: unknown
  token?: string
  googleToken?: string
}

interface ResponseBody {
  httpStatusCode: number
  timestamp: string
  result: string
  path: string
  data: {
    token?: string
    [key: string]: unknown
  }
  token?: string
}

const redacted = '[REDACTED]'

export const initializeLogRocket = () => {
  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production'

  //log rocket recording will only work for production
  //this is meant to reduce operation costs and prevent recordings in dev (automation/tests etc).

  if (isProduction) {
    LogRocket.init(`lropmc/${isProduction ? 'ce-production' : 'ce-dev'}`, {
      network: {
        requestSanitizer: (request) => {
          try {
            // Redact Authorization header if present
            if (request.headers && request.headers.Authorization) {
              request.headers.Authorization = redacted
            }

            // Check if the body exists
            if (request.body) {
              let sanitizedBody

              // Attempt to handle JSON-like payloads
              if (typeof request.body === 'string') {
                try {
                  // Parse JSON safely
                  const bodyObj = JSON.parse(request.body) as ParsedBody

                  // Perform sanitization for recognized keys
                  sanitizedBody = {
                    ...bodyObj,
                    ...(bodyObj.newPassword && { newPassword: redacted }),
                    ...(bodyObj.retypePassword && { retypePassword: redacted }),
                    ...(bodyObj.password && { password: redacted }),
                    ...(bodyObj.currentPassword && { currentPassword: redacted }),
                    ...(bodyObj.token && { token: redacted }),
                    ...(bodyObj.googleToken && { googleToken: redacted }),
                  }

                  // Return sanitized request
                  return {
                    ...request,
                    body: JSON.stringify(sanitizedBody),
                  }
                } catch (jsonError) {
                  // If JSON parsing fails, return the original request
                  return request
                }
              } else {
                // Non-string bodies are left unaltered and returned as is
                return request
              }
            }

            // Return request as-is if no body is present
            return request
          } catch (error) {
            console.error('Error sanitizing request:', error)
            return request
          }
        },
        responseSanitizer: (response) => {
          if (!response.body) {
            return response
          }

          try {
            const bodyObj = JSON.parse(response.body) as ResponseBody

            const sanitizedBody = {
              ...bodyObj,
              data: {
                ...bodyObj.data,
                token: redacted,
              },
              ...(bodyObj.token && { token: redacted }),
            }
            return {
              ...response,
              body: JSON.stringify(sanitizedBody),
            }
          } catch (error) {
            console.error('Error sanitizing response:', error)
            return response
          }
        },
      },
    })
  }
}
